'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoImage = function IoImage(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm26.3 17.5c-2.1 0-3.8-1.7-3.8-3.7s1.7-3.8 3.8-3.8 3.7 1.7 3.7 3.8-1.7 3.7-3.7 3.7z m6.5-12.5c1.3 0 2.2 0.9 2.2 2.2v25.6c0 1.3-0.9 2.2-2.2 2.2h-30.6c-1.3 0-2.2-0.9-2.2-2.2v-25.6c0-1.3 0.9-2.2 2.2-2.2h30.6z m-8 15.5l7.7 8.3v-20.4c0-0.5-0.5-0.9-1-0.9h-28c-0.5 0-0.9 0.4-1 0.9v20.4l9.8-11.9c0.4-0.3 0.8-0.6 1.4-0.6s1 0.1 1.3 0.5l4.2 4.6 0.3 0.3c0.3 0.2 0.6 0.3 0.9 0.3s0.6-0.1 0.9-0.4l1.4-1.2c0.3-0.2 0.7-0.4 1.1-0.4s0.7 0.2 1 0.5z' })
        )
    );
};

exports.default = IoImage;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/image.js
// module id = 2531
// module chunks = 168707334958949